import { downgradeComponent } from "@angular/upgrade/static";
import { AccountFeatures } from "@enums/account/AccountFeature";
import { AuthorizationService } from "@services/authorization.service";
import { HighChartsService } from "@services/highcharts.service";
import { RouteConfigHelperProvider } from "@services/routeConfigHelper.provider";
import { TemperatureNavigationModule } from "@temperature/temperature.navigation";
import { ReeferDetailComponent } from "@temperature/_components/reefer-detail/reefer-detail.component";
import { ReeferListComponent } from "@temperature/_components/reefer-list/reefer-list.component";
import { TemperatureGraphComponent } from "@temperature/_components/temperatureGraph/temperatureGraph.component";
import { TemperatureGraphComponent2 } from "@temperature/_components/tempGraph/temperature-graph.component";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { TemperatureComplianceComponent } from "./_components/compliance/temperature-compliance/temperature-compliance.component";

export class Config {
    static $inject = ["$stateProvider", "routeConfigHelperProvider"];

    constructor(
        private $stateProvider: StateProvider,
        private routeConfigHelperProvider: RouteConfigHelperProvider) {

        $stateProvider.state(TemperatureNavigationModule.ParentRoot, {
            abstract: true,
            url: "/temperature",
            redirectTo: TemperatureNavigationModule.Default,
            views: { "module-navigation": {} },
            data: { translation: 'Common.Temperature' }
        });

        $stateProvider.state(TemperatureNavigationModule.TemperatureCompliance, {
            url: "/vehicles/:page/:option",
            views: { "content@app": { component: "temperatureCompliance" } },
            params: {
                page: { squash: true, value: null, dynamic: true },
                option: { squash: true, value: null, dynamic: true }
            },
            data: { translation: "Common.Vehicles", subtitleTranslationKey: "Temperature.ComplianceSubtitle" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([], [AccountFeatures.Temperature])]
            }
        });

        $stateProvider.state(TemperatureNavigationModule.Reefer, {
            url: "/reefer",
            views: { "content@app": { component: "reeferList" } },
            params: {
                page: { squash: true, value: null, dynamic: true },
                option: { squash: true, value: null, dynamic: true }
            },
            data: { translation: "Temperature.Reefer", subtitleTranslationKey: "Temperature.ReeferSubtitle" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([], [AccountFeatures.Reefer])]
            }
        });

        this.createReeferRecordView(TemperatureNavigationModule.Reefer);

    }
    private createReeferRecordView(parentViewName: string) {
        this.routeConfigHelperProvider.createDetailStateWithBoundParams({
            stateName: `${parentViewName}.view`,
            translation: 'Temperature.Reefer',
            bindingName: "vehicleId",
            component: "reeferDetail",
            breadcrumbNameResolverKey: "reeferDetailNameKey"
        });
    }
}

angular
    .module("app.temperature", [
        "app.directives",
        "ui.router",
        "ngMaterial",
        "highcharts-ng"])
    .config(Config)
    .component("temperatureGraph", new TemperatureGraphComponent())

    .service("highChartsService", HighChartsService)

    .directive("reeferList", downgradeComponent({ component: ReeferListComponent }))
    .directive("reeferDetail", downgradeComponent({ component: ReeferDetailComponent }))
    .directive("tempGraph", downgradeComponent({ component: TemperatureGraphComponent2 }))
    .directive("temperatureCompliance", downgradeComponent({ component: TemperatureComplianceComponent }))

    ;
